exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".touch-action-manipulation[data-v-4e66f185] {\n  touch-action: manipulation;\n}\n.fade[data-v-4e66f185] {\n  animation-name: oz-overlay-fade-4e66f185;\n  animation-duration: 0.2s;\n  will-change: opacity;\n}\n@keyframes oz-overlay-fade-4e66f185 {\n0% {\n    opacity: 0;\n}\n100% {\n    opacity: 1;\n}\n}\n", ""]);

